import SectionHeader from "../components/ui/SectionHeader";
import { pricing } from "../data/siteData";

function PricingPage({ onNavigate }) {
  return (
    <section className="page-section">
      <div className="shell">
        <SectionHeader kicker="Cenik" title="Orientacni ceny">
          Finalni cena zalezi na rozsahu, pristupu k trasam a materialu. Cilem je mit zakladni predstavu pred nabidkou.
        </SectionHeader>

        <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_360px]">
          <div className="card overflow-hidden">
            {pricing.map(([name, price]) => (
              <div key={name} className="grid gap-2 border-b border-cyan-300/10 p-5 last:border-b-0 sm:grid-cols-[1fr_auto] sm:items-center">
                <span className="font-medium text-slate-200">{name}</span>
                <span className="font-semibold text-white">{price}</span>
              </div>
            ))}
          </div>

          <aside className="card p-6">
            <h2 className="text-xl font-bold text-white">Jak se cena potvrzuje</h2>
            <p className="mt-4 text-sm leading-6 text-slate-300">
              Po poptavce prijde kratka konzultace, pripadne prohlidka. Pak vznikne nabidka s jasnym rozsahem.
            </p>
            <button type="button" onClick={() => onNavigate("contact")} className="mt-6 btn-primary w-full">
              Poptat cenu
            </button>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default PricingPage;
